export default "__VITE_ASSET__D6C2auoZ__"